import { useContext, useEffect, useState, useRef } from 'react'
import css from "./teams.module.scss";
import { Layout } from "../../componentsV1/layout";
import Logo from "../../assets/v1/logo.png";
import { Scientist, Microscope, Settings, Innovators } from "../../assets/v1/icons";
import { getTeamsApi } from '../../api'
import Shapes from "./Shapes/shapes"
import { toAbsoluteUrl } from "../../utils/assetHelper"
import { AuthContext } from '../../context/auth'

export const Teams = () => {
  const teamRefs = useRef([]);
  const galleryUrl = `${process.env.REACT_APP_GALLERY_URL}300:350`
  const { setTeamModal } = useContext(AuthContext)
  const [teams, setTeams] = useState([])
  const [visibleTeams, setVisibleTeams] = useState([]);

  const logos = [
    {
      icon: Scientist,
      text: "Scientists"
    },
    {
      icon: Microscope,
      text: "Microscopists"
    },
    {
      icon: Settings,
      text: "Engineers"
    },
    {
      icon: Innovators,
      text: "Innovators"
    },
  ]

  const getTeamsData = () => {
    getTeamsApi().then((res) => {
      if (res.data) {
        const leadershipTeam = res?.data?.roles?.find(role => role.name === 'Leadership')?.teams?.sort((a, b) => a.order - b.order)?.map((item) => {
          return {
            type: css.orange,
            description: item.bio,
            ...item
          }
        })
        const advisorTeam = res.data.roles.find(role => role.name === 'Advisors')?.teams?.sort((a, b) => a.order - b.order)?.map((item) => {
          return {
            type: css.gray,
            description: item.bio,
            ...item
          }
        })
        const Team = res.data.roles.find(role => role.name === 'Team')?.teams?.sort((a, b) => a.order - b.order)?.map((item) => {
          return {
            type: css.blue,
            description: item.bio,
            ...item
          }
        })
        setTeams([...Team, ...advisorTeam, ...leadershipTeam].sort(customSort))
      }
    })
  }

  useEffect(() => {
    getTeamsData()
  }, [])


  const customSort = (a, b) => {
    const order = { orange: 2, blue: 1, gray: 3 };
    return order[a.type] - order[b.type];
  };

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const teamName = entry.target.dataset.name;
        if (entry.isIntersecting && !visibleTeams.includes(teamName)) {
          setVisibleTeams((prev) => [...prev, teamName]);
        }
      });
    }, {
      threshold: 0.8,
    });

    teamRefs.current.forEach(ref => {
      observer.observe(ref);
    });

    return () => {
      teamRefs.current.forEach(ref => {
        if (ref) observer.unobserve(ref);
      });
      observer.disconnect();
    };

  }, [teams]);

  return (
    <Layout>
      <div className={css.heroContainer}>
        <div className={css.heroContent}>
          <img src={Logo} alt="logo" className={css.heroLogo} />
          <div className={css.heroText}>
            <h1>The Scientists Behind The Data.</h1>
            <div className={css.line} />
            <p>Behind every validated reagent, every stepdown dataset, and every imaging workflow is a team of scientists, microscopists, engineers, and innovators commiteted to generating <span>data you can trust.</span></p>
          </div>
          <div className={css.logoWrapper}>
          <div className={css.logoContainer}>
            {logos.map((item) => {
              return (
                <div className={css.logo}>
                  <img src={item.icon} alt={item.text} />
                  <p>{item.text}</p>
                </div>
              )
            })
            }
          </div>
          <div className={css.row}>
            <div className={css.circle} />
            <div className={css.column}>
              <p>Identifyn® BRCA1 and 647</p>
              <p>STORM super-resolution image</p>
            </div>
          </div>
          </div>
        </div>
      </div>
      <div className={css.container}>
        <div className={css.teamsSection}>
          {
            teams.map((team, index) => {
              const orangeLast = teams.filter(t => t.type === 'orange')?.length
              const orangeLastName = teams.filter(t => t.type === 'orange')[orangeLast - 1]?.name
              const blueLast = teams.filter(t => t.type === 'blue')?.length
              const blueLastName = teams.filter(t => t.type === 'blue')[blueLast - 1]?.name
              const grayLast = teams.filter(t => t.type === 'gray')?.length
              const grayLastName = teams.filter(t => t.type === 'gray')[grayLast - 1]?.name
              const shouldNoIndex = ['Emin Ozandac', 'Harsh Malpani']?.includes(team?.name);

              const isVisible = visibleTeams.includes(team.name) || !shouldNoIndex;

              return (
                <div
                  key={team.id}
                  ref={(el) => { teamRefs.current[index] = el }}
                  data-name={team.name}
                  {...(shouldNoIndex && { 'data-nosnippet': '' })}
                  className={`${css.team}`} key={index + team.name}>
                  {isVisible &&
                    <>
                        {/* {team.image_layout ? <Shapes key={team.id} shapeType={team.image_layout} style={{ clipPath: `url(#svgPath-${team.image_layout}-text)`, backgroundImage: `url("${galleryUrl}:${team.image?.split('.com/')[1]}")` }} selectedPhoto={team.image} />
                          :
                          <img src={team.image ? galleryUrl + team.image : `${toAbsoluteUrl('/media/teams/blank.png')}`} alt="" />
                        } */}
                      <img src={team.image ? `${galleryUrl}:${team.image?.split('.com/')[1]}` : `${toAbsoluteUrl('/media/teams/blank.png')}`} alt="team_member" />
                      <div className={css.teamText}>
                        <h3>{team.name}</h3>
                        <h5>{(team.position_1)?.toLowerCase()}</h5>
                        {team.position_2 && <h5>{(team.position_1)?.toLowerCase()}</h5>}
                        <hr/>
                        <p>{team?.description?.substring(0, 280)}{team?.description ? team?.description?.length > 310 && '...' : ''}</p>
                        <button className={css.btn}
                          onClick={() => setTeamModal({
                            isOpen: true,
                            team
                          })}
                        >Read More</button>
                      </div>
                    </>
                  }
                </div>
              )
            })
          }
        </div>
      </div>
    </Layout>
  );
}